module.exports = __webpack_public_path__ + "img/vue2-semelle_rose.5bca69c5.png";